module.exports = __webpack_public_path__ + "static/media/manual.eb284964.jpeg";